<template>
  <div>
    <a-card :head-style="{ background: 'rgb(243, 243, 243)' }">
      <template #title> 角色管理 </template>
      <div class="card_header">
        <a-button style="margin-right: 10px" @click="addRole">
          <template #icon>
            <PlusOutlined />
          </template>
          增加角色</a-button
        >
        <a-row>
          <a-col :span="18">
            <a-input
              style="border-radius: 60px"
              placeholder="请输入角色名称"
              v-model:value="name"
              @keydown="handlerKey"
            >
              <template #suffix>
                <SearchOutlined />
              </template>
            </a-input>
          </a-col>
        </a-row>
      </div>
    </a-card>
    <div style="margin-top: 10px"></div>
    <a-table
      :columns="columns"
      :dataSource="data"
      bordered
      :row-selection="rowSelection"
      :pagination="false"
      :row-key="(record) => record.id"
    >
      <template #footer>
        <div class="header">
          <div class="left">
            <a-button class="mr c3">
              <template #icon><CaretRightOutlined /></template>
              批量启动</a-button
            >
            <a-button class="mr c2">
              <template #icon>
                <PauseOutlined />
              </template>
              批量禁用</a-button
            >
            <a-button class="mr c1">
              <template #icon>
                <CloseOutlined />
              </template>
              批量删除</a-button
            >
          </div>
          <div class="right">
            <df-pagination :model="pageObj"></df-pagination>
          </div>
        </div>
      </template>
      <template #operation="{ text, record, index }">
        <a-popover>
          <template #content>
            <p @click="addRole" style="color: #49d385">编辑</p>
            <p style="color: #f36d69">删除</p>
          </template>
          <span>操作</span>
        </a-popover>
      </template>
    </a-table>
    <!-- 弹出模态框 -->
    <a-modal
      v-model:visible="visible"
      title="添加角色"
      @ok="handleOk"
      :destroyOnClose="true"
    >
      <!-- @ok="handleOk" -->
      <a-form
        layout="horizontal"
        :ref="setsubmitForm"
        :model="submitForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="角色名称" v-if="!isedit">
          <a-input
            placeholder="角色名称"
            style="width: 282px"
            v-model:value="submitForm.name"
            @blur="validate"
          />
        </a-form-item>
        <a-form-item label="权限字符" name="roleKey">
          <a-input placeholder="权限字符" style="width: 282px" />
        </a-form-item>
        <a-form-item label="排序" name="roleSort">
          <a-input-number
            placeholder="排序"
            :min="1"
            :max="100"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="状态" name="main">
          <a-radio-group button-style="solid" default-value="0">
            <a-radio-button value="0"> 开启</a-radio-button>
            <a-radio-button value="1"> 关闭</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="菜单权限" name="menuIds">
          <df-selectMenuTreeClone
            :model="submitForm"
            @setValue="setValue"
            v-model:value="submitForm.menuIds"
            style="width: 282px"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import menu from "@axios/sysmenu";
import { nextTick, reactive, provide } from "vue";
import {
  PlusOutlined,
  SearchOutlined,
  CaretRightOutlined,
  PauseOutlined,
  CloseOutlined,
} from "@ant-design/icons-vue";
import { ref, computed } from "vue";
import { message } from "ant-design-vue";
import { useRouter } from "vue-router";
export default {
  components: {
    PlusOutlined,
    SearchOutlined,
    CaretRightOutlined,
    PauseOutlined,
    CloseOutlined,
  },
  setup() {
    let router = useRouter();
    let formState = reactive({
      name: "",
      menuIds: [],
    });
    let validate = () => {
      let params = {
        name: formState.name,
      };
      menu.onlyUser(params).then((res) => {
        console.log(res);
      });
    };
    let name = ref("");
    let visible = ref(false);
    let data = ref([]);
    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });
    const rowSelection = computed(() => {
      return {};
    });
    let ruleList = (name) => {
      let params = {
        name: name,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
      };
      menu.roleList(params).then((res) => {
        1;
        data.value = res.data;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;
      });
    };
    ruleList();
    let addRole = () => {
      visible.value = true;
    };
    let handlerOk = () => {
      visible.value = false;
    };
    let handlerKey = () => {
      ruleList(name.value);
    };
    let menuList = () => {
      menu.menuList().then((res) => {
        res.forEach((item) => {
          submitForm.pid = item.pid;
        });
      });
    };
    menuList();
    let submitForm = reactive({
      name: "",
      pid: "",
      menuIds: [],
    });
    const setValue = (val) => {
      submitForm.menuIds = val;
      Object.keys(val).forEach((item) => {
        submitForm.menuIds = val[item];
      });
    };
    let handleOk = () => {
      menu
        .addRole(submitForm)
        .then((res) => {
          message.success("增加成功");
          visible.value = false;
          ruleList();
        })
        .catch(() => {
          message.error("增加失败");
        });
    };
    const pageChange = (page) => {
      pageObj.value.page = page;
      ruleList();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      ruleList();
    };

    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);
    return {
      router,
      handleOk,
      setValue,
      submitForm,
      validate,
      formState,
      handlerKey,
      name,
      handlerOk,
      visible,
      addRole,
      pageObj,
      rowSelection,
      columns: [
        {
          key: "1",
          title: "角色名称",
          dataIndex: "name",
        },
        {
          key: "2",
          title: "角色说明",
          dataIndex: "remark",
        },
        {
          key: "3",
          title: "角色状态",
          dataIndex: "role",
        },
        {
          key: "4",
          title: "操作",
          slots: {
            customRender: "operation",
          },
        },
      ],
      data,
    };
  },
};
</script>

<style lang='scss' scoped>
/deep/ .ant-modal-content {
  height: 300px !important;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}
/deep/ .ant-card-head-title {
  padding: 10px 0;
  font-size: 14px;
}
/deep/ .ant-card-body {
  padding: 10px;
}
.card_header {
  display: flex;
}
/deep/ .ant-card-bordered {
  box-shadow: none;
}
.mr {
  margin-right: 10px;
}
.c1 {
  background: #f36d69 !important;
}
.c1:hover {
  background: #f36d69 !important;
  transform: scale(1.09);
}
.c2 {
  background: #feb248 !important;
}
.c2:hover {
  background: #feb248 !important;
  transform: scale(1.09);
}
.c3 {
  background: #669df6 !important;
}
.c3:hover {
  background: #669df6 !important;
  transform: scale(1.09);
}
/deep/ .ant-pagination {
  margin: 0 !important;
}
/deep/ .ant-table-footer {
  padding: 10px 16px;
}
p {
  cursor: pointer;
}
</style>